<div class="container-fluid">
    <section>
        <div>
            <div class="row">
                <div class="col-md-12">
                    <h1>
                        <span jhiTranslate="single-site-analysis.title">SINGLE-SITE ANALYSIS</span>&nbsp;
                        <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
                    </h1>
                </div>
            </div>
            <div *ngIf="isBrowseStudyScreen" class="mb-3">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col d-flex align-items-center">
                            <img class="image-icon-sm" src="content/images/search-nurseries.png">
                            <h4 style="padding-top: 5px;">
                                <span jhiTranslate="single-site-analysis.select-data-text">Select Data for Analysis</span>&nbsp;
                            </h4>
                        </div>
                    </div>
                    <div class="row" *ngIf="!study">
                        <div>
                            <a href (click)="browseStudy($event)" jhiTranslate="single-site-analysis.browse-link"></a>&nbsp;
                            <span class="ms-1" jhiTranslate="single-site-analysis.browse-text"></span>
                            <a class="ms-1" href (click)="uploadData($event)" jhiTranslate="single-site-analysis.upload-link"></a>&nbsp;
                            <span class="ms-1" jhiTranslate="single-site-analysis.upload-text"></span>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <div class="row">
                    <div class="col-md-6">
                        <h4>
                            <span class="bms-dataset" style="color: #FF4612; font-size: 15px;"></span>&nbsp;<b
                                jhiTranslate="single-site-analysis.panel-header.data.selected">DATA SELECTED FOR
                            ANALYSIS</b>
                        </h4>
                        <div class="row">
                            <label class="col-sm-3" jhiTranslate="single-site-analysis.field.label.study.name">Study
                                Name:</label>
                            <label class="col-sm-9" *ngIf="study">{{ study.name }}</label>
                        </div>
                        <div class="row pt-2">
                            <label class="col-sm-3"
                                   jhiTranslate="single-site-analysis.field.label.dataset">Dataset:</label>
                            <label class="col-sm-9" *ngIf="plotDatasetName">{{ plotDatasetName }}</label>
                        </div>
                        <div class="row pt-2">
                            <label class="col-sm-3" jhiTranslate="single-site-analysis.field.label.project.type">Project
                                Type:</label>
                            <label class="col-sm-9" *ngIf="study">{{ projectType }}</label>
                        </div>
                        <div class="row pt-2">
                            <label class="col-sm-3" jhiTranslate="single-site-analysis.field.label.description">Description:</label>
                            <label class="col-sm-9" *ngIf="study">{{ study.description }}</label>
                        </div>
                        <div class="row pt-2">
                            <label class="col-sm-3"
                                   jhiTranslate="single-site-analysis.field.label.objective">Objective:</label>
                            <label class="col-sm-9" *ngIf="study">{{ study.objective }}</label>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h4>
                            <span class="bms-factors" style="color: #39B54A; font-size: 18px;"></span>&nbsp;<b
                                jhiTranslate="single-site-analysis.panel-header.germplasm.descriptors">GERMPLASM
                            DESCRIPTORS</b>
                        </h4>
                        <div class="custom-scroll-style" style="height: 300px; overflow: auto;">
                            <table class="table table-striped table-bordered table-curved table-fixed"
                                   *ngIf="germplasmDescriptors.length else nodata">
                                <thead class="sticky-header">
                                <tr>
                                    <th><span jhiTranslate="single-site-analysis.table.headers.name">NAME</span></th>
                                    <th><span
                                            jhiTranslate="single-site-analysis.table.headers.description">DESCRIPTION</span>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let variable of germplasmDescriptors">
                                    <td>{{ variable.alias }}</td>
                                    <td>{{ variable.description }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row pt-3">
                    <div class="col-md-6">
                        <h4>
                            <span class="bms-variates" style="color: #B8D433; font-size: 20px;"></span>&nbsp;<b
                                jhiTranslate="single-site-analysis.panel-header.traits">TRAITS</b>
                        </h4>
                        <div>
                            <span jhiTranslate="single-site-analysis.covariates.label"></span>
                            <br/>
                            <br/>
                            <div class="custom-scroll-style" style="max-height: 300px; overflow: auto;">
                                <table class="table table-striped table-bordered table-curved table-fixed"
                                       style="margin-bottom: 0px;" *ngIf="traits.length else nodata">
                                    <thead class="sticky-header">
                                    <tr>
                                        <th><input type="checkbox" class="form-check-input" title="{{ 'global.select.all.items' | translate }}" [checked]="isAllTraitsSelected()"
                                                   (click)="onSelectAllTraits()"/></th>
                                        <th><span jhiTranslate="single-site-analysis.table.headers.name">NAME</span>
                                        </th>
                                        <th><span jhiTranslate="single-site-analysis.table.headers.description">DESCRIPTION</span>
                                        </th>
                                        <th><span jhiTranslate="single-site-analysis.table.headers.scale">SCALE</span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let variable of traits; trackBy: variableTrackId; index as index">
                                        <td><input type="checkbox" class="form-check-input" [checked]="isTraitSelected(variable)"
                                                   (click)="toggleTraitSelect(variable)"></td>
                                        <td>{{ variable.alias }}</td>
                                        <td>{{ variable.description }}</td>
                                        <td>{{ variable.scale }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div *ngIf="traits.length" class="col-md-12">
                                <div class="row pt-1">
                                    <div class="col">
                                        <div class="form-check form-check-inline" style="padding-top: 2px;">
                                            <input type="checkbox" class="form-check-input"
                                                   [checked]="isAllTraitsSelected()" (click)="onSelectAllTraits()">
                                            <label class="form-check-label" style="padding-top: 2px;" jhiTranslate="global.select.all.items">
                                                Select all
                                            </label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h4>
                            <span class="bms-variates" style="color: #B8D433; font-size: 20px;"></span>&nbsp;<b
                                jhiTranslate="single-site-analysis.panel-header.covariates">COVARIATES</b>
                        </h4>
                        <div>
                            <span jhiTranslate="single-site-analysis.covariates.label"></span>
                            <br/>
                            <br/>
                            <div class="custom-scroll-style" style="max-height: 300px; overflow: auto;">
                                <table class="table table-striped table-bordered table-curved table-fixed"
                                       style="margin-bottom: 0px;" *ngIf="covariates.length else nodata">
                                    <thead class="sticky-header">
                                    <tr>
                                        <th><input type="checkbox" class="form-check-input" title="{{ 'global.select.all.items' | translate }}" [disabled]="selectedTraits.length"
                                                   [checked]="isAllCovariatesSelected()"
                                                   (click)="onSelectAllCovariates()"/></th>
                                        <th><span jhiTranslate="single-site-analysis.table.headers.name">NAME</span>
                                        </th>
                                        <th><span jhiTranslate="single-site-analysis.table.headers.description">DESCRIPTION</span>
                                        </th>
                                        <th><span jhiTranslate="single-site-analysis.table.headers.scale">SCALE</span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let variable of covariates; trackBy: variableTrackId; index as index">
                                        <td><input type="checkbox" class="form-check-input" [disabled]="isTraitSelected(variable)"
                                                   [checked]="isCovariatesSelected(variable)"
                                                   (click)="toggleCovariateSelect(variable)"></td>
                                        <td>{{ variable.alias }}</td>
                                        <td>{{ variable.description }}</td>
                                        <td>{{ variable.scale }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div *ngIf="covariates.length" class="col-md-12">
                                <div class="row pt-1">
                                    <div class="col">
                                        <div class="form-check form-check-inline" style="padding-top: 2px;">
                                            <input type="checkbox" class="form-check-input"
                                                   [disabled]="selectedTraits.length"
                                                   [checked]="isAllCovariatesSelected()"
                                                   (click)="onSelectAllCovariates()">
                                            <label class="form-check-label" style="padding-top: 2px;" jhiTranslate="global.select.all.items">
                                                Select all
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!isBrowseStudyScreen" class="mb-3">
                <div class="col-md-12">
                    <div class="row">
                        <h4 style="padding-top: 5px;">
                            <span jhiTranslate="single-site-analysis.specify-options-text">Specify Options for Breeding View Analysis</span>&nbsp;
                        </h4>
                    </div>
                </div>
                <br/><br/>
                <div class="row">
                    <div class="col-md-6">
                        <h4>
                            <span class="bms-dataset" style="color: #FF4612; font-size: 15px;"></span>&nbsp;<b
                                jhiTranslate="single-site-analysis.panel-header.data.selected">DATA SELECTED FOR
                            ANALYSIS</b>
                        </h4>
                        <div class="row">
                            <label class="col-sm-3" jhiTranslate="single-site-analysis.field.label.study.name">Study
                                Name:</label>
                            <label class="col-sm-9" *ngIf="study">{{ study.name }}</label>
                        </div>
                        <div class="row pt-2">
                            <label class="col-sm-3"
                                   jhiTranslate="single-site-analysis.field.label.dataset">Dataset:</label>
                            <label class="col-sm-9" *ngIf="plotDatasetName">{{ plotDatasetName }}</label>
                        </div>
                        <div class="row pt-2">
                            <label class="col-sm-3" jhiTranslate="single-site-analysis.field.label.project.type">Project
                                Type:</label>
                            <label class="col-sm-9" *ngIf="study">{{ projectType }}</label>
                        </div>
                        <div class="row pt-2">
                            <label class="col-sm-3" jhiTranslate="single-site-analysis.field.label.description">Description:</label>
                            <label class="col-sm-9" *ngIf="study">{{ study.description }}</label>
                        </div>
                        <div class="row pt-2">
                            <label class="col-sm-3"
                                   jhiTranslate="single-site-analysis.field.label.objective">Objective:</label>
                            <label class="col-sm-9" *ngIf="study">{{ study.objective }}</label>
                        </div>
                        <br/>
                        <div class="row pt-2">
                            <div class="col-sm-12">
                                <label class="col-sm-12" jhiTranslate="single-site-analysis.field.label.analysis.name">Specify
                                    name for the analysis:</label>
                            </div>
                        </div>
                        <div class="row pt-2">
                            <div class="col-sm-8">
                                <input type="text" class="form-control" [(ngModel)]="analysisName" #code="ngModel"
                                       [required]="true"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h4>
                            <span class="bms-environments" style="color: #0076A9; font-size: 20px;"></span>&nbsp;<b
                                jhiTranslate="single-site-analysis.panel-header.choose.sites.environments">CHOOSE
                            SITES/ENVIRONMENT</b>
                        </h4>
                        <div>
                            <span jhiTranslate="single-site-analysis.sites.environment.label"></span>
                            <div class="row" style="padding-top: 10px;">
                                <label class="col-sm-5" style="padding-top: 10px;"
                                       jhiTranslate="single-site-analysis.field.label.environment.factor">Which factor
                                    defines the environment?</label>
                                <div class="col-sm-4">
                                    <ng-select name="environmentFactorsDropdown" id="environmentFactorsDropdown"
                                               width="100%"
                                               [(ngModel)]="selectedEnvironmentFactor"
                                               placeholder="{{ 'global.please.choose' | translate }}"
                                               [clearable]="false"
                                               required
                                    >
                                        <ng-option *ngFor="let factor of environmentVariables"
                                                   [value]="factor">{{ factor.alias }}
                                        </ng-option>
                                    </ng-select>
                                </div>
                            </div>
                            <br/>
                            <div class="row mb-2">
                                <label class="col-sm-12"
                                       jhiTranslate="single-site-analysis.field.label.select.environments">Select the
                                    environment you would like to send for analysis:</label>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div style="height: 300px; max-height: 300px; overflow-y: auto; overflow-x: hidden">
                                        <table class="table table-striped table-bordered table-curved table-fixed"
                                               *ngIf="(selectedEnvironmentFactor && environmentFactors.length) else nodata">
                                            <thead class="sticky-header">
                                            <tr>
                                                <th><span jhiTranslate="single-site-analysis.table.headers.select">SELECT</span>
                                                </th>
                                                <th><span jhiTranslate="single-site-analysis.table.headers.trial.instance">TRIAL INSTANCE</span></th>
                                                <th *ngIf="selectedEnvironmentFactor && selectedEnvironmentFactor.termId !== TRIAL_INSTANCE">
                                                    <span>{{ selectedEnvironmentFactor.alias }}</span></th>
                                            </tr>
                                            </thead>
                                            <tbody *ngIf="selectedEnvironmentFactor">
                                            <tr *ngFor="let factor of environmentFactors; trackBy: environmentFactorTrackId; index as index">
                                                <td><input type="checkbox" class="form-check-input" [checked]="isEnvironmentFactorSelected(factor)"
                                                           [disabled]="invalidEnvironmentFactorIds.includes(factor.instanceId)"
                                                           (click)="toggleEnvironmentFactorSelect(factor)"></td>
                                                <td>{{ factor.trialInstance }}</td>
                                                <td *ngIf="selectedEnvironmentFactor && selectedEnvironmentFactor.termId !== TRIAL_INSTANCE">{{ factor.idValueMap[selectedEnvironmentFactor.termId] }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="environmentFactors.length" class="row">
                                <div  class="col-md-12">
                                    <div class="form-check">
                                        <input type="checkbox" class="form-check-input"
                                               [disabled]="invalidEnvironmentFactorIds.length > 0"
                                               [checked]="isAllEnvironmentFactorSelected()"
                                               (click)="onSelectAllEnvironmentFactors()">
                                        <label class="form-check-label" style="padding-top: 2px;" jhiTranslate="global.select.all.items">
                                            Select all
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-6">
                        <h4>
                            <span class="bms-exp-design" style="color: #9A8478; font-size: 15px;"></span>&nbsp;<b
                                jhiTranslate="single-site-analysis.panel-header.specify.details">SPECIFY DESIGN
                            DETAILS</b>
                        </h4>
                        <span jhiTranslate="single-site-analysis.design.details.label"></span>
                        <div class="row" style="padding-top: 10px;">
                            <label class="col-sm-4" style="padding-top: 10px;"
                                   jhiTranslate="single-site-analysis.field.label.design.type">Specify the design
                                type:</label>
                            <div class="col-sm-6">
                                <ng-select name="designTypesDropdown" id="designTypesDropdown" width="100%"
                                           bindLabel="name"
                                           [items]="exptDesignTypes"
                                           [(ngModel)]="selectedExptDesignType"
                                           placeholder="{{ 'global.please.choose' | translate }}"
                                           [clearable]="false"
                                           required
                                >
                                    <ng-template ng-label-tmp let-item="item">
                                        {{item.name | translate}}
                                    </ng-template>
                                    <ng-template ng-option-tmp let-item="item">
                                        {{item.name | translate}}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                        <div class="row" style="padding-top: 10px;" *ngIf="showReplicatesFactorDropDown()">
                            <label class="col-sm-4" style="padding-top: 10px;"
                                   jhiTranslate="single-site-analysis.field.label.replicates.factor">Specify replicates
                                factor:</label>
                            <div class="col-sm-6">
                                <ng-select name="replicatesFactorsDropdown" id="replicatesFactorsDropdown" width="100%"
                                           bindLabel="name"
                                           [items]="repFactors"
                                           [(ngModel)]="selectedRepFactor"
                                           placeholder="{{ 'global.please.choose' | translate }}"
                                           [clearable]="true"
                                           [required]="selectedExptDesignType === ExperimentalDesignTypeEnum.RANDOMIZED_COMPLETE_BLOCK"
                                >
                                </ng-select>
                            </div>
                        </div>
                        <div class="row" style="padding-top: 10px;" *ngIf="showIncompleteBlockFactorDropDown()">
                            <label class="col-sm-4" style="padding-top: 10px;"
                                   jhiTranslate="single-site-analysis.field.label.block.factor">Specify incomplete block
                                factor:</label>
                            <div class="col-sm-6">
                                <ng-select name="incompleteBlockFactorsDropdown" id="incompleteBlockFactorsDropdown"
                                           width="100%"
                                           bindLabel="name"
                                           [items]="incompleteBlockFactors"
                                           [(ngModel)]="selectedIncompleteBlockFactor"
                                           placeholder="{{ 'global.please.choose' | translate }}"
                                           [clearable]="true"
                                           [required]="isIncompleteBlockFactorRequired()"
                                >
                                </ng-select>
                            </div>
                        </div>
                        <div class="row" style="padding-top: 10px;">
                            <label class="col-sm-4" style="padding-top: 10px;"
                                   jhiTranslate="single-site-analysis.field.label.row.factor">Specify row
                                factor:</label>
                            <div class="col-sm-6">
                                <ng-select name="rowFactorsDropdown" id="rowFactorsDropdown" width="100%"
                                           bindLabel="name"
                                           [items]="rowFactors"
                                           [(ngModel)]="selectedRowFactor"
                                           placeholder="{{ 'global.please.choose' | translate }}"
                                           [clearable]="true"
                                           [required]="isExptDesignRowCol()"
                                >
                                </ng-select>
                            </div>
                        </div>
                        <div class="row" style="padding-top: 10px;">
                            <label class="col-sm-4" style="padding-top: 10px;"
                                   jhiTranslate="single-site-analysis.field.label.col.factor">Specify column
                                factor:</label>
                            <div class="col-sm-6">
                                <ng-select name="colFactorsDropdown" id="colFactorsDropdown" width="100%"
                                           bindLabel="name"
                                           [items]="colFactors"
                                           [(ngModel)]="selectedColFactor"
                                           placeholder="{{ 'global.please.choose' | translate }}"
                                           [clearable]="true"
                                           [required]="isExptDesignRowCol()"
                                >
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h4>
                            <span class="bms-factors" style="color: #39B54A; font-size: 18px;"></span>&nbsp;<b
                                jhiTranslate="single-site-analysis.panel-header.specify.genotypes">SPECIFY GENOTYPES</b>
                        </h4>
                        <div class="row" style="padding-top: 10px;">
                            <label class="col-sm-2" style="padding-top: 10px;"
                                   jhiTranslate="single-site-analysis.field.label.genotypes">Genotypes:</label>
                            <div class="col-sm-6">
                                <ng-select name="genotypesDropdown" id="genotypesDropdown" width="100%"
                                           bindLabel="name"
                                           [items]="genotypeVariables"
                                           [(ngModel)]="selectedGenotype"
                                           placeholder="{{ 'global.please.choose' | translate }}"
                                           [clearable]="false"
                                           required
                                >
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="row">
                    <div class="col d-flex align-items-center">
                        <div class="ps-2" *ngIf="!isBrowseStudyScreen">
                            <button (click)="back($event)" type="button"
                                    class="btn btn-secondary ps-2" value="Back"
                                    jhiTranslate="back">
                                Back
                            </button>
                        </div>

                        <div class="ps-2">
                            <button (click)="cancel($event)" type="button" class="btn btn-secondary ps-2" value="Cancel"
                                    jhiTranslate="cancel">
                                Cancel
                            </button>
                        </div>
                        <div *ngIf="isBrowseStudyScreen" class="ps-2">
                            <button (click)="continue($event)" class="btn btn-primary ps-2"
                                    [disabled]="disableContinueButton()"
                                    jhiTranslate="single-site-analysis.button.continue">
                                <span *ngIf="isLoading" class="throbber throbber-btn"></span>
                                <span jhiTranslate="continue">Continue</span>
                            </button>
                        </div>

                        <div class="ps-2" *ngIf="!isBrowseStudyScreen">
                            <button (click)="download($event)" type="button"
                                    class="btn btn-primary ps-2" value="Download"
                                    jhiTranslate="single-site-analysis.button.download.input">
                                Download Input Files
                            </button>
                        </div>
                        <div class="ps-2" *ngIf="!isBrowseStudyScreen">
                            <button (click)="upload($event)" type="button"
                                    class="btn btn-primary ps-2" value="Upload"
                                    [routerLink]="['/', { outlets: { popup: 'single-site-analysis-import'} }]"
                                    [replaceUrl]="true"
                                    queryParamsHandling="merge"
                                    jhiTranslate="single-site-analysis.button.upload.input">
                                Upload Output Files to BMS
                            </button>
                        </div>

                    </div>
                </div>

            </div>
            <br/>
        </div>
        <ng-template #nodata>
            <table class="table table-striped table-bordered table-curved">
                <thead>
                <tr>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td jhiTranslate="no.data"></td>
                </tr>
                </tbody>
            </table>
        </ng-template>
    </section>
</div>
